import React from 'react';
import { Icon, Label, Menu } from 'semantic-ui-react';
import { uniqueKey } from '../../common/keys';

const MenuItemCenter = (props) => {
  const { menuProps } = props
  const { index, value, handleMenuClick, width, type, disabled, formattedItem, label } = menuProps
  return <Menu.Item key={uniqueKey('mi', index)} style={{ width: width }} onClick={e => !disabled && handleMenuClick('pick', type)} >
    {label && <Label size={'tiny'} color={'blue'}>{label}</Label>}
    {formattedItem ? formattedItem : value}
    <Icon name='caret down' />
  </Menu.Item>
}

export default MenuItemCenter